import { render } from 'preact';
import { App } from './app';
import { installLinkInterceptor } from './router';
import { initCast } from './state/cast';
import { initDownloads } from './state/downloads';
import { initPushMessageListener } from './lib/push';
import './styles.css';

installLinkInterceptor();

// Both detect the Android shell's bridge — downloads and Chromecast ride on the same channel.
// No-ops in every browser.
initDownloads();
initCast();
initPushMessageListener();


const root = document.getElementById('app');
if (root) render(<App />, root);

// Service worker registration lives in `public/sw-register.js`, loaded from index.html.
// Registering from here meant that a stale shell — which stops this bundle loading — also
// stopped the update that would have replaced the worker serving it.

/**
 * Ask for persistent storage up front.
 *
 * Origins in persistent mode are exempt from eviction. The grant is unreliable on iOS and
 * routinely denied, which is exactly why downloads are presented as best-effort.
 */
if (navigator.storage?.persist) {
  void navigator.storage.persisted().then((already) => {
    if (!already) void navigator.storage.persist().catch(() => {});
  });
}
